'use client'
import { memo, type PropsWithChildren } from 'react'

const VaultV2ActivityLayout = ({ children }: PropsWithChildren) => {
  return <div className="gap-lg sm:gap-xl flex w-[100%] flex-col">{children}</div>
}

export default memo(VaultV2ActivityLayout)
